var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn favorite",class:{ active: _vm.isFavoriteActive },attrs:{"type":"button","aria-label":"Favorito","title":_vm.isFavoriteActive ? `Remover dos favoritos` : `Adicionar aos favoritos`},on:{"click":_vm.OnFavoriteClick}},[_c('i',{staticClass:"far fa-heart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }